import { createFileRoute } from '@tanstack/react-router';
import { MeetingSettingsDefaults } from '@/pages/settings/MeetingSettingsDefaults';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/meeting/defaults')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['meetings.manageSettings'] }),
	component: MeetingSettingsDefaults,
});
